import React from 'react';
import { useAppStore, useTranslation } from '../store';

const OfflineIndicator = () => {
  const { isOnline } = useAppStore();
  const { t } = useTranslation();

  if (isOnline) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: '#ff6b6b',
      color: 'white',
      padding: '2px',
      textAlign: 'center',
      zIndex: 1000
    }}>
      {t('offlineWarning')}
    </div>
  );
};

export default OfflineIndicator;